import type { SupportedLocale } from '@/lib/utils/localization/getFlattenedLocales'
import type { CMSResult } from './types/CMSError'
import { getCosmicExclusiveContent } from './cosmic/fetchFunctions/getCosmicExclusiveContent'

export type GetExclusiveContentProps = {
  locale: SupportedLocale
}

export const getExclusiveContent = async ({
  locale,
}: GetExclusiveContentProps): Promise<CMSResult<
  ReturnType<typeof getCosmicExclusiveContent>
> | null> => {
  try {
    const exclusiveContent = await getCosmicExclusiveContent({
      locale,
    })

    if (!exclusiveContent || 'error' in exclusiveContent) {
      return {
        error: {
          code: 'COSMIC_EXCLUSIVE_CONTENT_DATA_MISSING',
          message:
            'Some exclusive content is temporarily unavailable. You can continue shopping normally.',
          source: 'cosmic',
          timestamp: new Date().toISOString(),
        },
      }
    }

    return exclusiveContent
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error)
    const errorDetails = {
      code: 'COSMIC_EXCLUSIVE_CONTENT_FETCH_FAILED',
      message:
        "We're having trouble loading our exclusive content. Please check back later.",
      source: 'cosmic' as const,
      details: errorMessage,
      timestamp: new Date().toISOString(),
    }

    console.error(
      'COSMIC: Unable to get exclusiveContent cosmic data:',
      errorDetails,
    )
    return { error: errorDetails }
  }
}
